import type { Board } from "../core/model";

export const ATTRACT_BOARD: Board = [
  [0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0],
  [5, 0, 0, 0, 0, 0],
  [3, 2, 2, 0, 5, 0],
  [1, 6, 1, 6, 4, 4],
  [1, 3, 4, 6, 1, 6],
  [4, 3, 6, 5, 6, 4],
  [4, 5, 2, 1, 4, 1]
];
